import React, {useCallback} from "react";
import {Box, Container, Typography, useMediaQuery, useTheme} from "@material-ui/core";
import { FullScreenBox, LoginPaper } from "../login/LoginPage";
import { useNotify } from "../../hooks/system/useNotify";
import { Alert, AlertTitle } from "@material-ui/lab";
import {PasswordResetRequestForm, PasswordResetRequestFormData} from "./PasswordResetRequestForm";
import {useApi} from "../../hooks/useApi";
import { useHistory, Switch, Route } from "react-router-dom";
import {PasswordResetForm, PasswordResetFormData} from "./PasswordResetForm";

export const PasswordResetPage = () => {
  const theme = useTheme(),
    isMobile = useMediaQuery(theme.breakpoints.down("sm")),
    { current, addNotify } = useNotify();

  const {api} = useApi(),
    history = useHistory()

  const onSubmitPasswordResetRequest = useCallback(
    async (date: PasswordResetRequestFormData) => {
      api.postSecurityRequestPasswordReset({requestPasswordReset: date})
        .then(() => addNotify('success', 'Password Reset Link Sent'))
        .catch(e => {
          if (e.status === 404) {
            addNotify('error', 'User not found with this email address')
          } else {
            addNotify('error', e.message)
          }
        })
    },
    [addNotify, api]
  );

  const onSubmitPasswordReset = useCallback(
    async (date: PasswordResetFormData) => {
      try {
        api.postSecurityResetPassword({resetPasswordRequest: date})
          .then(() => history.push('/password-reset/new-password'))
          .catch(e => {
            addNotify('error', e.message)
          })
      } catch (e) {}
    },
    [addNotify, api, history]
  );

  return (
    <>
      <Container maxWidth="md" disableGutters={isMobile}>
        <FullScreenBox width={isMobile ? "100%" : "auto"}>
          <LoginPaper elevation={isMobile ? 0 : 3} square={isMobile}>
            {current && (
              <Alert severity={current.variant}>
                <AlertTitle>
                  <b>{current.title}</b>
                </AlertTitle>
                {current.message}
              </Alert>
            )}
            <Box
              p={3}
              flexGrow={1}
              justifyContent="center"
              flexDirection="column"
              display="flex"
            >
              <Typography variant="h4">Password reset</Typography>
              <Switch>
                <Route exact path='/reset-password/:code'>
                  <PasswordResetForm  onSubmit={onSubmitPasswordReset}/>
                </Route>
                <Route exact path='/reset-password'>
                  <PasswordResetRequestForm  onSubmit={onSubmitPasswordResetRequest}/>
                </Route>
              </Switch>
            </Box>
          </LoginPaper>
        </FullScreenBox>
      </Container>
    </>
  );
};
